import { render, staticRenderFns } from "./LoadingPlaceholder.vue?vue&type=template&id=5842bbf8&scoped=true&"
import script from "./LoadingPlaceholder.vue?vue&type=script&lang=js&"
export * from "./LoadingPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5842bbf8",
  null
  
)

export default component.exports